import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import { notification } from "antd";
import { baseApiUrl } from "../../../services/api";

// Activez les modules nécessaires
SwiperCore.use([Autoplay, Pagination]);

function Logo() {
  const [partenaires, setPartenaires] = useState([]);
  const [loading, setLoading] = useState(true);

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  useEffect(() => {
    fetchPartenaires();
  }, []);

  const fetchPartenaires = async () => {
    try {
      setLoading(true);
      const response = await baseApiUrl.get("/partenaires/liste");
      console.log("Données reçues des partenaires:", response.data);

      // Vérifie que les données sont bien un tableau avant de les stocker
      setPartenaires(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Erreur lors de la récupération des partenaires:", error);
      openNotificationWithIcon("error", "Erreur lors du chargement des partenaires");
    } finally {
      setLoading(false);
    }
  };

  // Style commun pour toutes les images de partenaires
  const imageStyle = {
    width: '150px',  // Largeur fixe
    height: '100px', // Hauteur fixe
    objectFit: 'contain', // Garde le ratio tout en s'adaptant au conteneur
    margin: '0 auto', // Centre l'image horizontalement
    display: 'block', // Nécessaire pour le centrage
    backgroundColor: '#f8f9fa', // Fond léger pour les logos
    padding: '10px', // Espace autour du logo
    borderRadius: '5px', // Légère courbure des coins
  };

  // Style pour le conteneur de l'image
  const imageContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '120px', // Hauteur fixe pour tous les conteneurs
    marginBottom: '10px',
  };

  // Style pour le nom du partenaire
  const partenaireNameStyle = {
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: '500',
    color: '#444',
    marginTop: '8px',
    height: '40px', // Hauteur fixe pour le texte
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  return (
    <div className="partners-section py-5">
      {loading ? (
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Chargement...</span>
          </div>
          <p className="mt-2">Chargement des partenaires...</p>
        </div>
      ) : (
        <Swiper
          loop={true}
          speed={600}
          autoplay={{ delay: 5000 }}
          slidesPerView="auto"
          centeredSlides={true}
          pagination={{
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
              centeredSlides: true,
              spaceBetween: 20,
            },
            480: {
              slidesPerView: 2,
              centeredSlides: false,
              spaceBetween: 30,
            },
            640: {
              slidesPerView: 3,
              centeredSlides: false,
              spaceBetween: 40,
            },
            992: {
              slidesPerView: 4,
              centeredSlides: false,
              spaceBetween: 40,
            },
            1200: {
              slidesPerView: 5,
              centeredSlides: false,
              spaceBetween: 50,
            },
          }}
        >
          <div className="container" data-aos="zoom-in">
            {partenaires.map((partenaire, index) => (
              <SwiperSlide key={index}>
                <div className="testimonial-item partner-item">
                  <div style={imageContainerStyle}>
                    <a
                      href={partenaire.lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={partenaire.nom}
                    >
                      <img
                        src={baseApiUrl.defaults.baseURL + `/image/${partenaire.logo}`}
                        style={imageStyle}
                        alt={partenaire.nom}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/images/placeholder-logo.png'; // Image par défaut si erreur
                        }}
                      />
                    </a>
                  </div>
                  <div style={partenaireNameStyle}>
                    {partenaire.nom}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </div>
        </Swiper>
      )}
      <div className="swiper-pagination"></div>
    </div>
  );
}

export default Logo;
